import { render, staticRenderFns } from "./NewWhatsappV3Channel.vue?vue&type=template&id=1b228d5b&scoped=true"
import script from "./NewWhatsappV3Channel.vue?vue&type=script&lang=js"
export * from "./NewWhatsappV3Channel.vue?vue&type=script&lang=js"
import style0 from "./NewWhatsappV3Channel.vue?vue&type=style&index=0&id=1b228d5b&prod&lang=scss&scoped=true"
import style1 from "./NewWhatsappV3Channel.vue?vue&type=style&index=1&id=1b228d5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b228d5b",
  null
  
)

export default component.exports